// extracted by mini-css-extract-plugin
export var modal = "_df-0";